'use strict'

import { apiInstance } from './index'
import { mapArgs } from 'utils/functions'

const companyDataPurge = {
  create (companyId) {
    return apiInstance({
      method: 'POST',
      url: `/b2b-company-data-purge-app/anonymization/request/${companyId}`
    })
  },

  get (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: '/b2b-company-data-purge-app/anonymization/request',
      params
    })
  },

  confirm (companyId) {
    return apiInstance({
      method: 'PATCH',
      url: `/b2b-company-data-purge-app/anonymization/confirm/${companyId}`
    })
  },

  delete (companyId, data) {
    return apiInstance({
      method: 'DELETE',
      url: `/b2b-company-data-purge-app/anonymization/request/${companyId}`,
      data
    })
  }
}

export default companyDataPurge
